/**************************************************
 * Nombre:       Casilla_Avatar_Titulo_Dato
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {TableCell} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";

const Casilla_Contar_Arr = ({datos, dir, index}) => {

    return (
        <TableCell key={`as${8}e5`} variant={'body'} align={dir}
                   sx={{color: COLORTEXTO, fontSize: 14, fontWeight: 500}}>
            {datos ? datos.length : 0}
        </TableCell>

    )

}
export default Casilla_Contar_Arr